import { formatCurrency, formatMonth } from "../config/resources/utils";

export const DASHBOARD_CARD_CONFIG = {
  utmValue: {
    icon: 'las la-clipboard-list',
    label: 'Valor UTM',
    format: (v) => `${formatCurrency(v)}`,
    order: 1,
  },
  lastPensionValue: {
    icon: 'las la-clipboard-list',
    label: 'Pensión del mes',
    format: (v) => `${formatCurrency(v)}`,
    order: 2,
  },
  previousPensionValue: {
    icon: 'las la-clipboard-list',
    label: 'Mes anterior',
    format: (v) => `${formatCurrency(v)}`,
    order: 3,
  },
  pensionDiff: {
    icon: 'las la-clipboard-list',
    label: 'Variación',
    format: (v) => `${formatCurrency(v)}`,
    order: 4,
  },
  pensionGrowthPercentage: {
    icon: 'las la-clipboard-list',
    label: 'Variación (%)',
    format: (v) => `${formatCurrency(v)}`,
    order: 5,
  },
  lastPensionCreated: {
    icon: 'las la-clipboard-list',
    label: 'Mes de referencia',
    format: (v) => `${formatMonth(v)}`,
    order: 5,
  },
  totalUtms: {
    icon: 'las la-clipboard-list',
    label: 'UTMs',
    format: (v) => v,
    order: 6,
  },
  totalUsers: {
    icon: 'las la-users',
    label: 'Usuarios',
    format: (v) => v,
    order: 7,
  },
  totalPensionCalculations: {
    icon: 'las la-clipboard-list',
    label: 'Pensiones',
    format: (v) => v,
    order: 8,
  },
  totalLogs: {
    icon: 'las la-clipboard-list',
    label: 'Logs',
    format: (v) => v,
    order: 9,
  },
  totalPensions: {
    icon: 'las la-clipboard-list',
    label: 'Total Pensiones',
    format: (v) => v,
    order: 10,
  },
  totalProfiles: {
    icon: 'las la-clipboard-list',
    label: 'Perfiles',
    format: (v) => v,
    order: 11,
  },
}